import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormisForm, MCConfigService, MCFormValidationService } from "@maslul/common-services";
import { MCButtonComponent, MCFieldFormComponent } from "@maslul/common-components";
import { RequestDetailsService } from "../../../../../services/pages/request-details/request-details";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RequestDetailsStore } from "../../../../../services/store/request-details";
import { ProductsService } from "../../../../../services/pages/products/products";
import cloneDeep from 'clone-deep';
import { TranslateService } from "@ngx-translate/core";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { GeneralStore } from "../../../../../services/store/general";
import { RequestApprovalTypeDetailsStore } from "../../../../../services/store/approval-type-details-store";
import { TABS } from "../../../../../enum/request/TABS";


@Component({
    selector: 'mi-request-details',
    imports: [CommonModule,
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        GeneralSkeletonComponent,
        FocusOnTabDirective
    ],
    templateUrl: './request-details.html',
    styleUrl: './request-details.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class RequestDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {


    formisForm: FormisForm = new FormisForm();
    subscribtion: Subscription = new Subscription();
    tabsText: any;
    genericText: any;
    isExistAtachmnets: boolean = true;


    constructor(private requestDetailsService: RequestDetailsService,
        private formValidationService: MCFormValidationService,
        private requestDetailsStore: RequestDetailsStore,
        private productService: ProductsService,
        public override router: Router,
        private configService: MCConfigService,
        private translateService: TranslateService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private generalStore: GeneralStore) {

        super(router);
    }


    ngOnInit() {
        this.initFormisForm();
        this.initText();
        this.initIsExistAttachments();
    }

    initIsExistAttachments() {
        this.isExistAtachmnets = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.ATTACHMENTS);
    }

    initText() {

        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
    }



    initFormisForm() {
        this.formisForm.options.formState = cloneDeep(this.generalStore.getSnapshot().formState);
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.requestDetailsStore.getSnapshot().formisFormModel);
        this.initFields();


    }
    initFields() {
        this.subscribtion.add(
            this.requestDetailsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    next() {
        const isValid = this.formisForm.form.valid;

        this.requestDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid || this.configService.getConfiguration().noValidCheck == "true") {
            if (this.isExistAtachmnets) {
                this.navigation('attachments')
            } else {
                this.navigation('declarations');
            }

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('request details get invalid field', invalidFields);


        }
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }

    back() {
        this.moveToProduct();
    }

    moveToProduct(): void {
        this.requestDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        this.productService.prevToProductTab();
    }
}